// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isSupportCasesAppGroupIdResult = objectOf({
  case_id: string,
  case_number: string,
});
